module.exports = __webpack_public_path__ + "img/everydayink-desktop.96ecd3d0.webp";